import React, { Fragment } from "react";
import get from "lodash/get";
import { useFormikContext } from "formik";
import CombinationShow from "../CombinationShow";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchMerchantAccountTaxRates } from "actions/taxRate";
import { fetchMerchantAccountShippingRates } from "actions/shippingRate";
import {
  fetchMerchantAccountProductsPrices,
  fetchMerchantAccountCouponsPromotionCodes
} from "actions/merchantAccount";
import { fetchAppCheckout } from "actions/app";
import { fetchAttachments } from "actions/attachment";
import { ensureResources } from "utils/hooks";
import CombinationListItem from "../CombinationListItem";
import { STATE_KEYS } from "utils/constants/state";
import InfoIcon from "components/InfoIcon";
import MenuNavHeader from "components/MenuNavHeader";
import {
  CHECKOUT_PRODUCTS_COMBINATIONS_INFO,
  CHECKOUT_PRODUCTS_LOGIC_INFO
} from "constants/docs";
import { useCurrentFormFieldSelection } from "utils/hooks/manifest";
import isEqual from "lodash/isEqual";

import { CHECKOUT_PRODUCT_SETTINGS_INTENT } from "utils/constants/checkout";
import { EDITOR_MODE } from "utils/constants/editor";
import { getIconForUID } from "components/FormerEditor/utils";
import VideoModal from "components/VideoModal";
import { COMMAND_CONTENT_ID } from "components/CommandPalette/constants";
const BackIcon = getIconForUID("back");

const CombinationsList = (props) => {
  const { name } = props;
  const { values, setFieldValue } = useFormikContext();

  const inspectModeActive =
    get(values, STATE_KEYS.EDITOR.MODE) === EDITOR_MODE.INSPECT;
  const setModeAndIntent = (updatedIntent) => {
    if (inspectModeActive) {
      setFieldValue(STATE_KEYS.EDITOR.MODE, EDITOR_MODE.USE);
    }
    setFieldValue(STATE_KEYS.EDITOR.MENU_THIRD_INTENT, updatedIntent);
  };

  ensureResources(props.actions);

  const activeIndex = get(values, STATE_KEYS.EDITOR.MENU_ACTIVE_INDEX);

  const setActiveIndex = (index) => {
    setFieldValue(STATE_KEYS.EDITOR.MENU_ACTIVE_INDEX, index);
  };
  const currentSelection = useCurrentFormFieldSelection();

  const configCombinationsPath = `${name}.${STATE_KEYS.FORM.CONFIG_LOGIC_CHECKOUTS_COMBOS}`;
  const combinations = get(values, configCombinationsPath) || [];

  const fieldGroupsPath = `${name}.${STATE_KEYS.FORM.FIELD_GROUPS}`;
  const fieldGroups = get(values, fieldGroupsPath) || [];

  let content;
  const showCombination = Number.isInteger(activeIndex);

  if (showCombination) {
    const comboShowProps = {
      combinations,
      activeIndex,
      name
    };

    content = (
      <Fragment>
        <MenuNavHeader
          label="Logic"
          action={<InfoIcon slides={CHECKOUT_PRODUCTS_LOGIC_INFO} />}
        />
        <CombinationShow {...comboShowProps} />
      </Fragment>
    );
  } else {
    const combinationNodes = combinations.map((combination, index) => {
      const previewProps = {
        onClick: () => setActiveIndex(index),
        fieldGroups,
        combination,
        index: index,
        name,
        active: isEqual(combination.selections, currentSelection)
      };

      return (
        <li key={index} className="w-100">
          <CombinationListItem {...previewProps} />
        </li>
      );
    });

    content = (
      <Fragment>
        <MenuNavHeader
          label="Combinations"
          action={
            <VideoModal
              id={COMMAND_CONTENT_ID.CHECKOUT.SETUP_FIELD_COMBINATIONS}
            />
          }
        />
        <div className="bg-content--secondary pa2 bb hairline-1 bh--inset">
          <div
            onClick={() =>
              setModeAndIntent(CHECKOUT_PRODUCT_SETTINGS_INTENT.SET_FIELDS)
            }
            className="f6 fw5 pl2 link__underline color-primary pointer flex items-center"
          >
            <div className="pr1 flex">
              <BackIcon />
            </div>
            Fields
          </div>
        </div>
        <ul className="list ma0 pa0 w-100">{combinationNodes}</ul>
      </Fragment>
    );
  }

  return content;
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchAppCheckout,
      fetchMerchantAccountProductsPrices,
      fetchMerchantAccountCouponsPromotionCodes,
      fetchMerchantAccountTaxRates,
      fetchMerchantAccountShippingRates,
      fetchAttachments
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(CombinationsList);
